module.exports = __webpack_public_path__ + "static/52-Sweden-december2028-4968bef37de2f036a85a64a84ae0df5e.jpg";